export default {
  fontFamily: '"Pragmatica", Arial, sans-serif',
  h1: {
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    fontWeight: 800,
    fontSize: '60px',
    lineHeight: '100%',
    fontStyle: 'normal'
  },
  h2: {
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '120%',
    fontStyle: 'normal'
  },
  h3: {
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '120%',
    fontStyle: 'normal'
  },
  h4: {
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '120%',
    fontStyle: 'normal'
  },
  h5: {
    fontWeight: 500,
    fontSize: '16px',
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    lineHeight: '130%',
  },
  h6: {
    fontWeight: 500,
    fontSize: '14px',
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    lineHeight: '120%',
  },
  h7: {
    fontWeight: 500,
    fontSize: '12px',
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    lineHeight: '130%',
  },
  p1: {
    fontFamily: 'Pragmatica, Arial, sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '140%',
    fontStyle: 'normal'
  },
  p2: {
    fontFamily: 'Pragmatica, Arial, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
    fontStyle: 'normal'
  },
  p3: {
    fontFamily: 'Pragmatica, Arial, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '130%',
    fontStyle: 'normal'
  },
  p4: {
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '140%',
    fontStyle: 'normal'
  },
  caption1: {
    fontFamily: 'Pragmatica, Arial, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '120%',
    fontStyle: 'normal'
  },
  caption2: {
    fontFamily: '"Pragmatica Extended", Arial, sans-serif',
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '120%',
    fontStyle: 'normal'
  }
}
